import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHSixtyPreLogin',
    name: 'IFPageOneHSixtyPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixty/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageOneHSixtyLogin' || from.path === '/IFPageOneHSixtyLoginSecond') {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHSixtyLogin',
    name: 'pageOneHSixtyLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixty/login.vue'),
  },
  {
    path: '/IFPageOneHSixtyLoginLoading',
    name: 'pageOneHSixtyLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixty/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtyLeaveInfo',
    name: 'pageOneHSixtyLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixty/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtyResult',
    name: 'pageOneHSixtyResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixty/result.vue'),
  },
  {
    path: '/IFPageOneHSixtyLoading',
    name: 'pageOneHSixtyLoading',
    component: () => import('@/pages/pageListAll/pageOneHSixty/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHSixtyLoginSecond',
    name: 'pageOneHSixtyLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHSixty/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyOnline',
    name: 'pageOneHSixtyOnline',
    component: () => import('@/pages/pageListAll/pageOneHSixty/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHSixtyLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHSixtyGuide',
    name: 'pageOneHSixtyLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHSixty/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
      path: '/IFPageOneHSixtyCar',
      name: 'pageOneHSixtyCar',
      component: () => import('@/pages/pageListAll/pageOneHSixty/car.vue'),
      meta: {
        title: '补充留资',
      },
    },
    {
      path: '/IFPageOneHSixtyCarDetails',
      name: 'pageOneHSixtyCarDetails',
      component: () => import('@/pages/pageListAll/pageOneHSixty/carDetails.vue'),
      meta: {
        title: '申请结果',
      },
    },*/
  {
    path: '/IFPageOneHSixtyBlank',
    name: 'pageOneHSixtyBlank',
    component: () => import('@/pages/pageListAll/pageOneHSixty/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyOnlineTab',
    name: 'pageOneHSixtyOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHSixty/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyOnlineAd',
    name: 'pageOneHSixtyOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHSixty/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
